let fileUploadCounter = 0,
	scriptList = [],
	styleList = [],
	isUploading = false;

function ActivateUpload() {
	let myURL = PJQ.app.options.uploadUrl + '/DesktopModules/PanteraModuleGlobal/FileUpload/FileTransferHandler.ashx?folder=0&uid=' + fileUploadGuid + '&sid=' + pjqSessionId,
		$fileUpload = jQuery('#fileupload');
	$fileUpload.attr('action', myURL);
	$fileUpload.fileupload();
	let fuOpts = {
		autoUpload: true,
		url: myURL
	};
	if (window.location.href.indexOf('9457') === -1) {
		fuOpts.uploadTemplateId = 'pod-upload';
		fuOpts.downloadTemplateId = 'pod-download';
	}
	$fileUpload.fileupload('option', fuOpts);
	$fileUpload.bind('fileuploadstart', function (e, data) {
		jQuery('.dropnotice').css('display', 'none');
		isUploading = true;
	});

	$fileUpload.bind('fileuploadadd', function (e, data) {
		jQuery('.dropnotice').css('display', 'none');
	});

	$fileUpload.bind('fileuploadstop', function (e, data) {
		if (null != $('button.start')) {
			$('button.start', $fileUpload).prop('disabled', false);
			$('button.start', $fileUpload).removeClass('ui-button-disabled');
			$('button.start', $fileUpload).removeClass('ui-state-disabled');
		}
		if (null != $('button.cancel')) {
			$('button.cancel', $fileUpload).prop('disabled', false);
			$('button.cancel', $fileUpload).removeClass('ui-button-disabled');
			$('button.cancel', $fileUpload).removeClass('ui-state-disabled');
		}
		isUploading = false;
		$('.alert-wait-upload').addClass('hidden');
	});

	$fileUpload.bind('fileuploaddestroyed', function (e, data) {
		if (jQuery("#printondemand-files table[role='presentation'] tbody tr").length == 0) {
			jQuery('.dropnotice').css('display', '');
		}
	});

// if the browser is IE, expose an iFrame and load the file templates to it
	if (pjqIsIE || pjqBrowserVersion == 11) {
		jQuery('#private-dragdrop-notice').text('Files Attached:');
		jQuery('#printondemand-files').css('border', 'solid 1px black');
		jQuery('.dropnotice').css('display', 'none');
		jQuery('#if-upload-private').removeClass('pjq-hidden');

		styleList = [];
		jQuery('link').each(function () {
			if (jQuery(this).attr('href') && (
				jQuery(this).attr('href').toString().indexOf('PJQ.css') > 0 ||
				jQuery(this).attr('href').toString().indexOf('Pantera.css') > 0 ||
				jQuery(this).attr('href').toString().indexOf('/jquery/') > 0 ||
				jQuery(this).attr('href').toString().indexOf('/jqueryui/') > 0 ||
				jQuery(this).attr('href').toString().indexOf('/FileUpload/') > 0
			))
				styleList.push(jQuery(this).attr('href'));
		});

		scriptList = [];
		jQuery('script').each(function () {
			if (jQuery(this).attr('src') && (
				jQuery(this).attr('src').toString().indexOf('/jquery/') > 0 ||
				jQuery(this).attr('src').toString().indexOf('/jqueryui/') > 0 ||
				jQuery(this).attr('src').toString().indexOf('/JQuery-bbq/') > 0 ||
				jQuery(this).attr('src').toString().indexOf('/FileUpload/') > 0
			))
				scriptList.push(jQuery(this).attr('src'));
		});

		jQuery('#if-upload-private').insertAfter($fileUpload);

		var dlframe = getObj('if-upload-private');
		var doc = dlframe.contentDocument;
		if (doc == undefined || doc == null)
			doc = dlframe.contentWindow.document;
		var val = '<html><head>', i = 0;
		for (i = 0; i < styleList.length; i++)
			val = val + "<link rel='stylesheet' type='text/css' href='" + styleList[i] + "' />";

		val = val + jQuery('#PJQPrintOnDemand-Documents-CSS').outerHTML();
		val = val + "<" + "style type='text/css'>.html, .body {width: 100%;} div.fileupload-buttonbar { width: 100% !important; padding-top: 4px !important; } td.delete span.ui-icon,td.cancel span.ui-icon { top: 20% !important; left: 0.3em !important; } input[type='files'] { display: none; z-index: 0; } .btn { margin-left: 0px !important; } .btn, .btn i, .btn span { padding: 1px !important;  }  #printondemand-files table tbody tr td span { font-size: 10pt; padding: 0px !important; margin: 0px !important; } table.printondemand-file-table { padding-top: 0px !important; width: 100% !important; } #printondemand-files { height: 129px !important; width: 100% !important; font-family: Arial; font-size: 10pt; } <" + "/style" + ">";
		val = val + '</head><body style="padding:0px; margin:0px; background-color: transparent;" onload="AfterLoadInit()">';
		val = val + "<a id='pms-upload-clear' href='javascript:void(0)' onclick='ClearUploads()' class='pjq-hidden'></a>";
		val = val + $fileUpload.outerHTML();
		val = val + jQuery('#template-upload').outerHTML();
		val = val + jQuery('#template-download').outerHTML();

		for (i = 0; i < scriptList.length; i++)
			val = val + "<script type='text/javascript' src='" + scriptList[i] + "' >" + "<" + "/script" + ">";

		val = val + "<" + "script type='text/javascript'" + ">";
		val = val + "function AfterLoadInit() {";

		val = val + " $fileUpload.attr('action', '" + myURL + "');";
		val = val + " $fileUpload.fileupload();";
		val = val + " $fileUpload.fileupload('option', { autoUpload: true, url: '" + myURL + "' });";
		val = val + " $fileUpload.bind('fileuploadstop', function(e, data) {";
		val = val + "    if (null != $('button.start')) {";
		val = val + "       $('button.start', $fileUpload).prop('disabled', false);";
		val = val + "       $('button.start', $fileUpload).removeClass('ui-button-disabled');";
		val = val + "       $('button.start', $fileUpload).removeClass('ui-state-disabled');";
		val = val + "    }";
		val = val + "    if (null != $('button.cancel')) {";
		val = val + "       $('button.cancel', $fileUpload).prop('disabled', false);";
		val = val + "       $('button.cancel', $fileUpload).removeClass('ui-button-disabled');";
		val = val + "       $('button.cancel', $fileUpload).removeClass('ui-state-disabled');";
		val = val + "    }";
		val = val + "    if (jQuery(\"#printondemand-files table[role='presentation'] tbody tr\").length > 0) {";
		val = val + "       jQuery('#files-added-btn', window.parent.document).click()}";
		val = val + "    jQuery('#pms-fuc', window.parent.document).click();";
		val = val + " });";
		val = val + " $fileUpload.bind('fileuploadstart', function (e, data) {";
		val = val + "    jQuery('.dropnotice').css('display', 'none');";
		val = val + " });";
		val = val + " $fileUpload.bind('fileuploadadd', function (e, data) {";
		val = val + "    jQuery('.dropnotice').css('display', 'none');";
		val = val + " });";
		val = val + " $fileUpload.bind('fileuploaddestroy', function (e, data) {";
		val = val + "    jQuery('#files-zero-btn', window.parent.document).click();";
		val = val + " });";

		val = val + "$('#step2button').click(function() {jQuery('#run-step2', window.parent.document).click();});";
		val = val + "$('#cancel-upload').click(function() {jQuery('#run-cancel', window.parent.document).click();});";

		val = val + "}";
		val = val + "function ClearUploads() {";
		val = val + "   jQuery('tr.template-download').remove();";
		val = val + "}";
		val = val + "<" + "/script" + ">";
		val = val + '</body></html>';
		doc.open();
		doc.write(val);
		doc.close();

		$fileUpload.remove();
	}
	else {
		jQuery('#if-upload-private').addClass('pjq-hidden');
		$('#step2button').click(function () {
			Step2Click()
		});
		$('#cancel-upload').click(function () {
			CancelClick()
		});
	}
}

function UpdateFileCounter() {
	fileUploadCounter = fileUploadCounter + 1;
}

function Step2Click() {
// Hide the Downloads page and display the Order options page
	this.$('.alert-wait-upload').addClass('hidden');
	if (isUploading) {
		this.$('.alert-wait-upload').removeClass('hidden');
	}
	else if (jQuery("#printondemand-files table[role='presentation'] tbody tr").length > 0 || ((pjqIsIE || pjqBrowserVersion == 11) && FilesAddedCount > 0)) {
		jQuery('#pod-documents').addClass('pjq-hidden');
		jQuery("#pod-options").removeClass('pjq-hidden');
	}
	else
		showInfoDialog('No Files Selected', 'No files selected for upload.. Please select a file');
}